<footer class="footer">
  <p-card>
    <div class="flex flex-row mx-2">
      <div class="text-sm imprint pl-3">
        LipidCompass is brought to you by:
      </div>
    </div>
    <div class="flex flex-row justify-content-between flex-wrap mx-2">
      <!-- <figure
        class="flex flex-1 flex-auto align-items-center justify-content-start m-1 p-0 pl-3"
      >
        <a
          href="https://dsbms.github.io/"
          target="_blank"
          title="DSBMS, IBG-5, Forschungszentrum Jülich"
          ><img
            src="assets/img/dsbms-logo-2026.png"
            class="figure-img"
            alt="DSBMS Logo"
        /></a>
      </figure> -->
      <figure
        class="flex flex-1 flex-auto align-items-center justify-content-center m-1 p-0"
      >
        <a
          href="https://lifs-tools.org"
          target="_blank"
          title="Lipidomics Informatics for Life Science"
          ><img
            src="assets/img/LIFS-signet-2017x03x13-transp-small.png"
            class="figure-img2"
            alt="LIFS Logo"
        /></a>
      </figure>
      <figure
        class="flex flex-1 flex-auto align-items-center justify-content-center m-1 p-0"
      >
        <a
          href="https://fz-borstel.de/index.php/en/"
          target="_blank"
          title="Research Center Borstel - Leibniz Lung Center, Borstel"
          ><img
            src="assets/img/fz-borstel-en.jpg"
            class="figure-img"
            alt="FZ Borstel Logo"
        /></a>
      </figure>

      <figure
        class="flex flex-1 flex-auto align-items-center justify-content-center m-1 p-0"
      >
        <a
          href="https://www.mpi-cbg.de/home/"
          target="_blank"
          title="Max Planck Insitute of Molecular Cell Biology and Genetics, Dresden"
          ><img
            src="assets/img/mpi-logo.png"
            class="figure-img"
            alt="MPI CBG Logo"
        /></a>
      </figure>

      <figure
        class="flex flex-1 flex-auto align-items-center justify-content-center m-1 p-0"
      >
        <a
          href="https://www.univie.ac.at/"
          target="_blank"
          title="University of Vienna, Vienna"
          ><img
            src="assets/img/uni-wien-logo.jpg"
            class="figure-img"
            alt="Uni Wien Logo"
        /></a>
      </figure>

      <figure
        class="flex flex-1 flex-auto align-items-center justify-content-end m-1 p-0 pr-3"
      >
        <a
          href="https://www.fz-juelich.de"
          target="_blank"
          title="Research Center Juelich, Juelich"
          ><img
            src="assets/img/fz-juelich-logo.png"
            class="figure-img"
            alt="Forschungszentrum Jülich Logo"
        /></a>
      </figure>
    </div>
    <hr class="light-hr mb-3" />
    <div class="flex flex-row mx-2">
      <div class="text-sm imprint pl-3">
        LipidCompass development and operations are supported by:
      </div>
    </div>
    <div class="flex flex-row justify-content-between flex-wrap mx-2">
      <figure
        class="flex flex-1 flex-auto align-items-center justify-content-start m-1 p-0 pl-3"
      >
        <a
          href="https://lipidomicssociety.org"
          target="_blank"
          title="Supported by the International Lipidomics Society"
          ><img
            src="assets/img/ils-logo.png"
            height="50px"
            class="figure-img2"
            alt="ILS Logo"
        /></a>
        <!-- <figcaption class="small">Funded by the BMBF</figcaption> -->
      </figure>
      <figure
        class="flex flex-1 flex-auto align-items-center justify-content-center m-1 p-0"
      >
        <a
          href="https://www.bmftr.bund.de/"
          target="_blank"
          title="Funded by the German Federal Ministry for Research, Technology and Space (BMFTR)"
          ><img
            src="assets/img/BMFTR_en_Web_RGB_gef_durch.png"
            height="110px"
            class="figure-img2"
            alt="BMFTR / BMBF Logo"
        /></a>
        <!-- <figcaption class="small">Funded by the BMBF</figcaption> -->
      </figure>
      <!-- Logo_BMBWF.png -->
      <figure
        class="md:ml-8 md:mt-3 flex flex-1 flex-auto align-items-center justify-content-center m-1 p-0"
      >
        <a
          href="https://www.bmbwf.gv.at/"
          target="_blank"
          title="Funded by the Austrian Federal Ministry of Education, Science and Research"
          ><img
            src="assets/img/Logo_BMBWF.png"
            height="50px"
            class="figure-img2"
            alt="BMBWF Logo"
        /></a>
        <!-- <figcaption class="small">Funded by the Austrian Federal Ministry of Education, Science and Research</figcaption> -->
      </figure>
      <figure
        class="md:ml-8 md:mt-3 flex flex-1 flex-auto align-items-center justify-content-center m-1 p-0"
      >
        <div>
          <a
            href="https://lifescience-ri.eu/ls-login/"
            target="_blank"
            title="Authentication via Life Science Login (LS AAI)"
            ><img
              src="https://lifescience-ri.eu/fileadmin/lifescience-ri/media/Images/login-grey-wide.jpg.png"
              height="50px"
              class="figure-img2"
              alt="Life Science Login Logo"
          /></a>
          <figcaption class="small text-center">
            Authentication via LS AAI
          </figcaption>
        </div>
      </figure>
      <figure
        class="md:ml-8 md:mt-3 flex flex-1 flex-auto align-items-center justify-content-end m-1 p-0 pr-3"
      >
        <div>
          <a
            href="https://cloud.denbi.de/"
            target="_blank"
            title="Hosted on the de.NBI Cloud"
            ><img
              src="assets/img/deNBI_logo.jpg"
              height="50px"
              class="figure-img2"
              alt="de.NBI Logo"
          /></a>
          <figcaption class="small text-center">
            Hosted on the de.NBI Cloud
          </figcaption>
        </div>
      </figure>
    </div>
    <hr class="light-hr mb-3" />
    <div
      class="flex flex-row justify-content-between align-content-start flex-wrap mx-2 mb-3"
    >
      <div
        class="flex flex-column align-items-start justify-content-begin flex-wrap"
      >
        <ul class="imprint imprint-links">
          <li>
            <span class="mr-2">&copy;</span
            ><span class="mr-2">{{ copyrightDate | date: "yyyy" }}</span
            ><a href="https://lifs-tools.org">LIFS</a>
          </li>
          <li>
            <a href="https://lifs-tools.org/imprint-privacy-policy.html"
              >Imprint & Data Protection</a
            >
          </li>
          <li>
            <a href="https://lifs-tools.org/terms-of-service.html"
              >Terms of Service</a
            >
          </li>
        </ul>
      </div>
      <div class="flex flex-column justify-content-begin flex-wrap">
        <div class="text-sm imprint pl-3">
          @if (backendInfo(); as info) {
          @if (info.git?.commit?.id; as commitId) {
          <div>
            <strong>Version:</strong>&nbsp;{{
              info.build?.version || "N/A"
            }}<br />
            <strong>Branch:</strong>&nbsp;{{
              ((info.git?.branch ?? "") | gitShortHash) || "N/A"
            }}<br />
            <strong>Commit:</strong>&nbsp;<a
              href="https://github.com/lifs-tools/lipidcompass/commit/{{
                commitId
              }}"
              target="_blank"
              >{{ commitId }}</a
            ><br />
          </div>
          } @else {
          <strong>Version:</strong>&nbsp;{{
            info.build?.version || "N/A"
          }}<br />
          @if(info.build?.artifact) {
          <strong>Build:</strong>&nbsp;{{
            info.build?.artifact || "N/A"
          }}
          } } }
        </div>
      </div>
    </div>
  </p-card>
</footer>
